module.exports = __webpack_public_path__ + "static/media/tada.0b68c2ae.png";